import { c as _c } from "react/compiler-runtime";
import { useFilters } from "@website/widget/filter";
import { useVillaFiltersSchema } from "./index.constant";
export const useVillagesFilter = (hotelListResultsCount, isListingDataFetched) => {
  const $ = _c(8);
  const {
    filtersSchema,
    chipsFiltersSchema,
    hasNearby
  } = useVillaFiltersSchema(isListingDataFetched);
  let t0;
  if ($[0] !== filtersSchema) {
    t0 = {
      schema: filtersSchema
    };
    $[0] = filtersSchema;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    clearFilters
  } = useFilters(t0);
  let t1;
  if ($[2] !== chipsFiltersSchema || $[3] !== clearFilters || $[4] !== filtersSchema || $[5] !== hasNearby || $[6] !== hotelListResultsCount) {
    t1 = {
      hasNearby,
      clearAllFilters: clearFilters,
      filtersSchema,
      chipsFiltersSchema,
      hotelListResultsCount
    };
    $[2] = chipsFiltersSchema;
    $[3] = clearFilters;
    $[4] = filtersSchema;
    $[5] = hasNearby;
    $[6] = hotelListResultsCount;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
};